export var setLocalStorage = function (key, value) {
    localStorage.setItem(key, value);
};
export var getLocalStorage = function (key, defaultValue) {
    var _a;
    if (defaultValue === void 0) { defaultValue = ""; }
    return (_a = localStorage.getItem(key)) !== null && _a !== void 0 ? _a : defaultValue;
};
